import React from "react";
import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";

export const SubscriptionContext = React.createContext();

const DetailQuery = gql`
  query SubscriptionDetailQuery($id: ID) {
    subscriptionDetails(id: $id) {
      uniqueIdentifier
      cardExpiryMonth
      cardExpiryYear
      maskedCardNumber
      subscriptionTermType
      cancelledAt
      lastChargedAt
      registeredAt
      state
      ticketArticleName
      subscriptionTypeName
      registrationFinalizedAt
      updatePaymentCardUrl
      charges {
        amount
        chargedAt
        dueDate
        status
      }
    }
  }
`;

const SubscriptionProvider = (props) => {
  const { subscriptionId } = props;

  const { loading, error, data } = useQuery(DetailQuery, {
    variables: {
      id: subscriptionId,
    },
  });

  if (error) return <h3>{error.message}</h3>;

  return (
    <SubscriptionContext.Provider value={{ data, subscriptionId, loading }}>
      {props.children}
    </SubscriptionContext.Provider>
  );
};

export default SubscriptionProvider;
